/** @format */
import { AxiosResponse, CancelToken } from 'axios';

import { QueryResponse } from '@toucan/common/services/search/types';

import { client } from '@toucan/client/global/axios';

export async function fetchQuoteProductConditions(
    queryParams: string,
    cancelToken: CancelToken | undefined,
    locale: string
) {
    const { data }: AxiosResponse<QueryResponse> = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            cancelToken,
            headers: {
                'Content-Language': locale,
            },
        }
    );

    return data;
}

export async function fetchQuoteBuyProducts(
    queryParams: string,
    cancelToken: CancelToken | undefined,
    locale: string
) {
    const { data }: AxiosResponse<QueryResponse> = await client.get(
        `/search-service/product/query/?${queryParams}`,
        {
            cancelToken,
            headers: {
                'Content-Language': locale,
            },
        }
    );

    return data;
}
